exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".obj-dialog[data-v-6edc6eea]{background-image:var(--dialogBgImg);padding:20px}.obj-dialog[data-v-6edc6eea],.obj-dialog .header[data-v-6edc6eea]{background-repeat:no-repeat;background-size:100% 100%}.obj-dialog .header[data-v-6edc6eea]{background-image:var(--diyCardTitleBg);height:36px;line-height:40px}", ""]);

// exports
